import { Check } from 'lucide-react'

// Negrito inline via **...**
function rich(text) {
  return text.split('**').map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index} className="font-inter-bold">
        {part}
      </strong>
    ) : (
      part
    ),
  )
}

// Caixa azul de destaque (Importante / checklist), com barra lateral #2B7FFF.
function CalloutBox({ children }) {
  return (
    <div className="flex flex-col gap-4 border-[#2B7FFF] border-l-4 bg-gradient-to-r from-[#EFF6FF] to-white py-6 pr-8 pl-9">
      {children}
    </div>
  )
}

export default function CultureCallout({
  sectionTitle,
  sectionLead,
  principles = [],
  aiFirst,
}) {
  return (
    <div className="flex w-full flex-col gap-12 px-20">
      {(sectionTitle || sectionLead) && (
        <div className="flex flex-col gap-4">
          {sectionTitle && (
            <h2 className="font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
              {sectionTitle}
            </h2>
          )}
          {sectionLead && (
            <p className="font-inter-regular text-base leading-relaxed text-[#333333]">
              {sectionLead}
            </p>
          )}
        </div>
      )}

      {principles.map((principle, index) => (
        <div key={index} className="flex flex-col gap-[39px]">
          <div className="flex flex-col gap-[15px]">
            <h3 className="font-inter-bold text-2xl leading-8 text-[#454545]">
              {principle.title}
            </h3>
            <p className="whitespace-pre-line font-inter-regular text-base leading-[1.6] text-[#364153]">
              {rich(principle.body)}
            </p>
          </div>
          {principle.important && (
            <CalloutBox>
              <div className="flex flex-col gap-1">
                <p className="font-inter-semibold text-sm leading-5 text-[#1C398E]">
                  Importante:
                </p>
                <p className="font-inter-regular text-sm leading-5 text-[#1C398E]">
                  {rich(principle.important)}
                </p>
              </div>
            </CalloutBox>
          )}
        </div>
      ))}

      {aiFirst && (
        <div className="flex flex-col gap-10 rounded-[10px] border border-[#E5E7EB] bg-gradient-to-br from-[#F9FAFB] to-white px-[33px] py-8">
          <div className="flex flex-col gap-4">
            <h3 className="font-inter-bold text-2xl leading-9 text-[#454545]">
              {aiFirst.title}
            </h3>
            <p className="whitespace-pre-line font-inter-regular text-base leading-[1.6] text-[#364153]">
              {rich(aiFirst.body)}
            </p>
          </div>

          {aiFirst.checklist?.length > 0 && (
            <CalloutBox>
              {aiFirst.calloutLabel && (
                <p className="font-inter-semibold text-sm leading-5 text-[#454545]">
                  {aiFirst.calloutLabel}
                </p>
              )}
              <ul className="flex flex-col gap-2">
                {aiFirst.checklist.map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <Check
                      size={16}
                      className="mt-0.5 shrink-0 text-[#00D4B4]"
                    />
                    <span className="font-inter-regular text-sm leading-5 text-[#4A5565]">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </CalloutBox>
          )}
        </div>
      )}
    </div>
  )
}
